module.exports = __webpack_public_path__ + "static/media/refunded-purchase.c0c7bdd0.svg";